import * as Immutable from 'immutable';
import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { getLastAnnouncements } from '../../../actions/Dashboard/AnnouncementActions';
import { makeItScroll } from '../../../actions/MessagesActions';
import { StateType } from '../../../reducers';
import {
  announcementsDataSelector,
  announcementsIsFetchingSelector,
} from '../../../reducers/DashboardReducer/AnnouncementsReducer/AnnouncementsSelector';
import { DispatchConnect } from '../../../types/';

import { AnnouncementsPropsGeneric, AnnouncementsStateDispatchers, AnnouncementsStateProps } from './types';
import AnnouncementsMain from './AnnouncementsMain';
import analytics from '../../../shared/services/analytics/analytics';

class Announcements extends React.Component<AnnouncementsPropsGeneric> {
  UNSAFE_componentWillMount() {
    this.props.dispatchGetDashboardAnnouncements();
  }

  handleMakeItScroll = (id: string, source: string) => {
    this.props.dispatchMakeItScroll(id);
    analytics.trackCustomEvent('click_announcement', { event_category: source, event_label: id });
  };

  render() {
    return (
      <AnnouncementsMain
        data={this.props.enabledIntro ? Immutable.List() : this.props.data}
        isFetching={this.props.isFetching}
        getAnnouncements={this.props.dispatchGetDashboardAnnouncements}
        handleMakeItScroll={this.handleMakeItScroll}
      />
    );
  }
}

const mapStateToProps = (state: StateType): AnnouncementsStateProps => ({
  // @ts-ignore
  data: announcementsDataSelector(state),
  // @ts-ignore
  isFetching: announcementsIsFetchingSelector(state),
});

const mapDispatchToProps = (dispatch: Dispatch<any>): AnnouncementsStateDispatchers => ({
  dispatchGetDashboardAnnouncements: async () => dispatch(getLastAnnouncements()),
  dispatchMakeItScroll: (id: string) => {
    dispatch(makeItScroll(id));
  },
});

export default connect<AnnouncementsStateProps, DispatchConnect<AnnouncementsStateDispatchers>, any, StateType>(
  mapStateToProps,
  mapDispatchToProps
)(Announcements);
